import SubscriptionArticleModelBase from '../_generated/modelBases/subscription-article-model-base';

export default class SubscriptionArticleModel extends SubscriptionArticleModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
